/**
 * A small on-brand palette so each column is visually distinct without the
 * board turning into a rainbow. Cycled by column index.
 *
 * These use the `lane-*` theme tokens rather than raw palette colours, so the
 * accents re-tune themselves in dark mode along with everything else.
 */
export interface ColumnAccent {
  bar: string;
  pill: string;
  noteBorder: string;
  dropRing: string;
  addHover: string;
  glow: string;
  /**
   * The raw colour, for the `--lane` custom property a post-it's paper is
   * mixed from. Tailwind classes can't express that mix, and the notes have to
   * keep saying which column they belong to now they sit wherever they like.
   */
  lane: string;
}

export const COLUMN_ACCENTS: ColumnAccent[] = [
  {
    bar: "bg-lane-1",
    pill: "bg-lane-1/12 text-lane-1",
    noteBorder: "border-l-lane-1/60",
    dropRing: "ring-lane-1/45",
    addHover: "hover:bg-lane-1/8 hover:text-lane-1",
    glow: "from-lane-1/8",
    lane: "var(--color-lane-1)",
  },
  {
    bar: "bg-lane-2",
    pill: "bg-lane-2/12 text-lane-2",
    noteBorder: "border-l-lane-2/60",
    dropRing: "ring-lane-2/45",
    addHover: "hover:bg-lane-2/8 hover:text-lane-2",
    glow: "from-lane-2/8",
    lane: "var(--color-lane-2)",
  },
  {
    bar: "bg-lane-3",
    pill: "bg-lane-3/12 text-lane-3",
    noteBorder: "border-l-lane-3/60",
    dropRing: "ring-lane-3/45",
    addHover: "hover:bg-lane-3/8 hover:text-lane-3",
    glow: "from-lane-3/8",
    lane: "var(--color-lane-3)",
  },
  {
    bar: "bg-lane-4",
    pill: "bg-lane-4/12 text-lane-4",
    noteBorder: "border-l-lane-4/60",
    dropRing: "ring-lane-4/45",
    addHover: "hover:bg-lane-4/8 hover:text-lane-4",
    glow: "from-lane-4/8",
    lane: "var(--color-lane-4)",
  },
];

export function accentFor(index: number): ColumnAccent {
  return COLUMN_ACCENTS[index % COLUMN_ACCENTS.length];
}
